"use client";

import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { Check, ArrowRight } from "lucide-react";

export function CtaSection() {
  const router = useRouter();

  const features = [
    "Real-time notifications for new leaks",
    "Track unlimited artists",
    "Discord & email alerts",
    "No credit card required"
  ];

  return (
    <div className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-8">
            <span className="inline-flex items-center rounded-md bg-purple-400/10 px-4 py-2 text-sm font-medium text-purple-400 ring-1 ring-inset ring-purple-400/20">
              Limited Time Offer
            </span>
          </div>

          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl bg-clip-text text-transparent bg-gradient-to-r from-white to-purple-300">
            Start Your Free Account Today
          </h2>
          
          <p className="mt-6 text-lg leading-8 text-gray-300">
            Join the community of music enthusiasts who always stay ahead of the curve. 
            Set up your alerts in less than 2 minutes.
          </p>

          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-4 text-left">
              {features.map((feature) => (
                <div key={feature} className="flex items-center">
                  <Check className="h-5 w-5 text-purple-500 mr-2 flex-shrink-0" />
                  <span className="text-sm text-gray-300">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <Button
              onClick={() => router.push('/sign-in')}
              className="bg-purple-600 hover:bg-purple-500 text-lg py-6 px-8 w-full sm:w-auto group relative overflow-hidden transition-all duration-300"
            >
              <span className="relative z-10 flex items-center justify-center">
                Create Free Account
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-purple-500 opacity-0 group-hover:opacity-100 transition-opacity" />
            </Button>
          </div>

          <p className="mt-6 text-sm text-gray-400">
            No credit card required. Cancel anytime.
          </p>
        </div>
      </div>
    </div>
  );
}